import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MenuService } from 'src/services/menu.service';
import { PageContentService } from 'src/services/pagecontent.service';
import { BroadcastMessageService } from 'src/services/broadcastMessageService';
import { AppSettings, Settings } from 'src/app/app.settings';
import { MatDialog } from '@angular/material';
import { Alert } from 'selenium-webdriver';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatMenuTrigger } from '@angular/material'
import swal from 'sweetalert2';



@Component({
    selector: 'app-horizontal-menu',
    templateUrl: './horizontal-menu.component.html',
    styleUrls: ['./horizontal-menu.component.scss'],
    providers: [MenuService]
})
export class HorizontalMenuComponent implements OnInit {

    @Input('menuParentId') menuParentId;
    // public menuItems: Array<Menu> = [];
    subscription: Subscription
    //router: any;
    public langId: number;
    public settings: Settings;
    horizontalMenuLists: any;




    constructor(public menuService: MenuService, public pageservice: PageContentService,
        private broadcastMessageService: BroadcastMessageService, public appSettings: AppSettings,
        public router: Router, public dialog: MatDialog) {
        this.settings = this.appSettings.settings;
        this.subscription = this.broadcastMessageService.getMessage().subscribe(message => {
            this.langId = +message.text;
            //this.menuService.getHorizontalMenuItems(true, this.langId).subscribe(result => {
            //    this.menuItems = [];
            //    if (result != null && result != undefined) {
            //        result.forEach(element => {
            //            this.menuItems.push(new Menu(element.id, element.title, element.routeLink, element.href, element.target, element.hasSubmenu, element.parentMenu_Id, element.menuIcon, element.iconColor, element.isStatic));
            //        });
            //        this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);

            //    }
            //});
            this.menuService.getVerticalMenuItems(true, this.langId).subscribe(result => {
                this.horizontalMenuLists = result;
                //console.log('ff', this.horizontalMenuLists);

            });

            this.router.navigate(['/home']);
        });
    }

    ngOnInit() {

        // this.langId = localStorage.langId;  
        this.langId = this.settings.langId;
        //this.menuService.getHorizontalMenuItems(true, this.langId).subscribe(result => {

        //    if (result != null && result != undefined) {
        //        result.forEach(element => {
        //            this.menuItems.push(new Menu(element.id, element.title, element.routeLink, element.href, element.target, element.hasSubmenu, element.parentMenu_Id, element.menuIcon, element.iconColor, element.isStatic));
        //        });
        //        this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
        //    }
        //});
        //this.getMenuList();
        this.menuService.getVerticalMenuItems(true, this.langId).subscribe(result => {
            this.horizontalMenuLists = result;
            this.horizontalMenuLists.forEach(element => {
                if(element.title=="Recruitment")
                {
                    element.isRecruitmentPage=true;
                }
            });
           
            //console.log('ff', this.horizontalMenuLists);

        });
    }
    getMenuList() {
        this.langId = this.settings.langId;
        this.menuService.getVerticalMenuItems(true, this.langId).subscribe(result => {
            this.horizontalMenuLists = result;
            // console.log('ff', this.horizontalMenuLists);
            // console.log('fo', this.langId);
        });
    }
    onmenu(event) {
        this.broadcastMessageService.sendMessage(event);
    }

    openChatDialog(menuTitle) {
        

        if (menuTitle == "CHAT for help") {
            swal.fire({
                title: "CHAT for Help",
                text: "",
                showCancelButton: true,
                confirmButtonText: "தமிழில் உரையாட",
                cancelButtonText: "Chat in English (Coming Soon)",
                showCloseButton: true,
                imageUrl: 'assets/images/chatbot-selection.png',
            }).then((result) => {
                if (result.value) {
                    window.open('http://78.46.86.133:8080/chatbot/', '_blank');
                }
            })

        } else {
            //window.open("http://13.71.123.144:10511/digivol-registration.html", "_blank");

            this.router.navigate(['/digivolunteer']);

        }
    }
}

